import { router, routerFuns } from 'sw-hic'

routerFuns.init({
    scheduleView: () => import('@/components/scheduleView'),
    shiftTypeView: () => import('@/components/shiftTypeView'),
    shiftTypeSeriesView: () => import('@/components/shiftTypeSeriesView')
})

// Redirect default 'leisure' idle page → scheduleView
router.beforeEach((to, from, next) => {
    if (to.name === 'leisure') {
        return next({ name: 'scheduleView', replace: true })
    }
    next()
})

export default router
